import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFE5D4",
    d: "M10 1.667a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667m3.922 5.66a.833.833 0 0 1 0 1.18L9.34 13.09a.833.833 0 0 1-1.178 0l-2.084-2.084a.833.833 0 1 1 1.179-1.178l1.494 1.494 3.994-3.994a.833.833 0 0 1 1.178 0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#F56A00",
    d: "M13.923 7.327a.833.833 0 0 1 0 1.179l-4.584 4.583a.833.833 0 0 1-1.178 0l-2.084-2.083a.833.833 0 1 1 1.179-1.179l1.494 1.494 3.994-3.994a.833.833 0 0 1 1.179 0"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }